export default __webpack_public_path__ + "static/barfi-83e63fc56600657fcd570cec600e1749.png";